<template>
  <div>
    <Header>
      Dodawanie użytkownika
    </Header>

    <b-row>
      <b-col xl="6">
        <Errors/>

        <b-form @submit.prevent="submit">
          <b-form-group label="Nazwa">
            <b-input v-model="form.name" required/>
          </b-form-group>
          <b-form-group label="Login">
            <b-input v-model="form.login" required/>
          </b-form-group>
          <b-row>
            <b-col xl="6">
              <b-form-group label="Hasło">
                <b-input v-model="form.password" type="password" autocomplete="new-password" required/>
              </b-form-group>
            </b-col>
            <b-col xl="6">
              <b-form-group label="Powtórz hasło">
                <b-input v-model="form.password_confirm" type="password" autocomplete="new-password" required/>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group label="Rola">
            <b-select v-model="form.role" :options="select_roles"/>
          </b-form-group>
          <b-form-group>
            <div class="d-flex justify-content-between">
              <div>
                <inertia-link
                  :href="route('users.index')"
                  as="b-button"
                  variant="secondary"
                >
                  <b-icon icon="x"/>
                  Anuluj
                </inertia-link>
              </div>
              <div>
                <b-button type="submit" variant="primary" :disabled="form.processing">
                  <b-icon icon="plus"/>
                  Dodaj
                </b-button>
              </div>
            </div>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Layout from '@/Layouts/Default'
import Header from '@/Layouts/Components/Header'
import Errors from '@/Layouts/Components/Errors'

export default {
  layout: Layout,
  components: {
    Errors,
    Header,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: '',
        login: '',
        role: 'user',
        password: '',
        password_confirm: '',
      }),
    }
  },
  computed: {
    select_roles() {
      return [
        {value: 'user', text: 'Użytkownik'},
        {value: 'moderator', text: 'Moderator'},
        {value: 'admin', text: 'Admin'},
      ]
    },
  },
  methods: {
    submit() {
      this.form.post(this.route('users.store'))
    },
  },
}
</script>
